import { useMutation } from "urql";

import { UpdateOfferLetterDocument } from "../../../graphql/generated.ts";

export const useUpdateOfferLetter = () =>
  useMutation(UpdateOfferLetterDocument);
